<template>
  <div class="moz-form-group">
    <div class="moz-label">
      <slot name="label" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MozFormGroup',
};
</script>

<style lang="scss" scoped>
.moz-form-group {
  width: 100%;
  max-width: 752px;
}

.moz-label {
  margin-bottom: 8px;
  font-size: 11px;
  color: #fff;

  @media screen and (min-width: $tablet-width) {
    font-size: 14px;
  }
}
</style>
